<template>
    <div>
        <v-progress-circular indeterminate size="20" :width="3" color="primary" class="progress"></v-progress-circular>
        <template v-if="message !== false">{{ message || $t('LOADING_MESSAGE')}}</template>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
@Component({})
export default class Loading extends Vue {
    @Prop() message;
}
</script>

<style>
.progress {
    vertical-align: top;
    padding-right: 2.5em;
}
</style>